<app-layout title="Tu Perfil">

  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'tab1'" (click)="changeTab('tab1')">Datos Personales</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'tab2'" (click)="changeTab('tab2')">Firma Digital</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'tab3'" (click)="changeTab('tab3')">Información Bancaria</a>
    </li>
  </ul>

  <div class="tab-content mt-3">
    <div class="tab-pane fade" [class.show]="activeTab === 'tab1'" [class.active]="activeTab === 'tab1'" id="tab1">
      <div class="bg-white text-dark rounded-bottom ">
        <form [formGroup]="profileForm" (ngSubmit)="saveProfile()" *ngIf="userId!=''">
          <div class="container2 m-3 bg-white">
            <div class="row">
              <!-- Columna 1 -->
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="rut" class="form-label fw-bold">RUT</label>
                  <input type="text" class="form-control" id="rut" formControlName="rut">
                </div>
                <div class="mb-3">
                  <label for="missionaryCode" class="form-label  fw-bold">Código de empleado</label>
                  <input type="text" class="form-control" id="missionaryCode" formControlName="employee_code">
                </div>
                <div class="mb-3">
                  <label for="userRole" class="form-label fw-bold">Rol de Usuario</label>
                  <div *ngIf="userRole === 'Administrador'">
                    <select id="userRoleSelect" class="form-select" formControlName="user_role">
                      <option [ngValue]="null" disabled selected>Selecciona un rol:</option>
                      <option *ngFor="let role of userRoles" [value]="role._id">
                        {{ role.name }}
                      </option>
                    </select>
                  </div>

                  <p *ngIf="userRole!='Administrador'">{{userRole}}</p>
                </div>
              </div>

              <!-- Columna 2 -->
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="nombre" class="form-label fw-bold">Nombre</label>
                  <input type="text" class="form-control" id="nombre" formControlName="name">
                </div>
                <div class="mb-3">
                  <label for="email" class="form-label fw-bold">Email</label>
                  <input type="email" class="form-control" id="email" formControlName="email">
                </div>
                <div class="mb-3">
                  <label for="clave" class="form-label fw-bold">Cambiar clave</label>
                  <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="password"
                    formControlName="password">
                  <div class="d-flex justify-content-end mt-1">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                      (click)="showPassword = !showPassword">
                      <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                      {{ showPassword ? 'Ocultar' : 'Mostrar' }}
                    </button>
                  </div>
                </div>
              </div>
              
            </div>
          </div>

          <button type="submit" class="btn btn-sm btn-success m-3" [disabled]="!profileForm.valid"><i
              class="fa fa-save"></i> Guardar Cambios</button>
        </form>
        <div *ngIf="userId==''" class="alert alert-danger" role="alert">
          No se ha encontrado el usuario.
        </div>
      </div>
    </div>
    <div class="tab-pane fade" [class.show]="activeTab === 'tab2'" [class.active]="activeTab === 'tab2'" id="tab2">
      <div class="mb-3">
        <div class="m-3">
          <p>Sigue estos pasos para subir tu firma digital al sistema en formato imagen <strong>(.jpg o .png)</strong>:</p>
          <ul>
            <li>Asegúrate de tener tu firma escaneada o fotografiada de forma clara.</li>
            <li>El archivo debe estar en formato <strong>JPG</strong> o <strong>PNG</strong>.</li>
            <li>El tamaño del archivo no debe superar los <strong>2 MB</strong>.</li>
            <li>Después de seleccionar el archivo, presiona <em>“Guardar”</em> o <em>“Actualizar firma”</em>.</li>
            <li>Espera el mensaje de confirmación que indique que tu firma ha sido guardada correctamente.</li>
          </ul>
        
          <p class="mt-4 fw-bold">✅ Recomendaciones</p>
          <ul>
            <li>La firma debe ser legible, con buen contraste sobre fondo blanco.</li>
            <li>No se aceptan archivos en formato <strong>PDF</strong> o <strong>Word</strong>.</li>
            <li>Si tienes problemas, puedes contactar al soporte técnico del sistema.</li>
          </ul>
        </div>
        
        <div class="m-5">
          <input type="file" class="form-control mt-3" id="firma" (change)="onFileSelected($event)">
          <div class="mt-3" *ngIf="signatureUrl">
            <label class="form-label fw-bold">Firma actual:</label><br>
            <img [src]="signatureUrl" alt="Firma digital" style="max-height: 150px; border: 1px solid #ccc; padding: 5px;">
          </div>
          <button type="button" class="btn btn-sm btn-success m-3" (click)="uploadSignature()">
            <i class="fa fa-upload"></i> {{ signatureId ? 'Actualizar firma' : 'Guardar firma' }}
          </button>    
          <button *ngIf="signatureId" type="button" class="btn btn-sm btn-danger m-3" (click)="deleteSignature()">
            <i class="fa fa-trash"></i> Eliminar firma
          </button>
        </div>
      </div>
    </div>
    <div class="tab-pane fade" [class.show]="activeTab === 'tab3'" [class.active]="activeTab === 'tab3'" id="tab3">
      <app-add-edit-user-bank-information></app-add-edit-user-bank-information>
    </div>
  </div>


</app-layout>